import { TypeMediaReleaseArticleSnapshotWithoutUnresolvableLinksResponse } from 'contentful-types'
import Palette from '@telus-uds/palette-allium/build/web/palette'
import { FlexGrid, List, Paragraph, Spacer } from '@telus-uds/components-web'

export const getArticleSnapshots = (snapshots: TypeMediaReleaseArticleSnapshotWithoutUnresolvableLinksResponse[]) => {
  return snapshots?.map((snapshot, i) => {
    const offset = i % 2 == 0 ? 2 : 0

    return (
      <FlexGrid.Col key={snapshot.sys.id} xs={12} sm={12} md={12} lg={4} xl={4} lgOffset={offset} xlOffset={offset}>
        <List tokens={{ itemBulletColor: Palette.color.greyCharcoal }}>
          <List.Item>
            <Paragraph variant={{ size: 'small', bold: true, colour: 'secondary' }} align={'left'}>
              {snapshot.fields.content}
            </Paragraph>
          </List.Item>
        </List>
        <Spacer space={1} />
      </FlexGrid.Col>
    )
  })
}
